import "../styles/globals.scss";
import { Inter, Poppins, Montserrat } from "next/font/google";
import Navbar from "@/src/Shared/Navbar/HomeNavbarV2";
import { GlobalProvider } from "@/src/context/GlobalContext";
import Footer from "@/src/Shared/Footer/FooterV2";

// import cron job for cache clear
// import "@/cron/clearCache";

const inter = Inter({
  subsets: ["latin"],
  variable: "--font-inter",
  weight: ["400", "500", "600", "700"],
});

const poppins = Poppins({
  subsets: ["latin"],
  variable: "--font-poppins",
  weight: ["400", "700"],
});

const montserrat = Montserrat({
  subsets: ["latin"],
  variable: "--font-montserrat",
  weight: ["400", "600"],
});

function MyApp({ Component, pageProps }: any) {
  const {...restPageProps } = pageProps;
  const isAdsPage = pageProps?.isAdsPage;

  return (
    <div
      className={`${inter.variable} ${poppins.variable} ${montserrat.variable}`}
    >
      <GlobalProvider>
        {!isAdsPage && <Navbar slugInfo={pageProps?.slugInfo} />}
        <Component {...restPageProps} />
      </GlobalProvider>
      {/* {!isAdsPage && <Footer data={footerData} />} */}
      {!isAdsPage && <Footer />}
    </div>
  );
}

export default MyApp;
